import { TCampaign } from 'gql'
import React from 'react'
import { Link } from 'react-router'
import { formatAmount, Routes } from 'shared'
import './campaign_card_styles.sass'

export type CampaignCardCampaign = Pick<TCampaign, 'photoUrl' | 'title' | 'receivedCents' | 'goalCents'>

export const CampaignCard = ({ campaign }: { campaign: CampaignCardCampaign }) => (
  <a
    href={Routes.campaignOrRegistrationPath(campaign)}
    className="ui link card raised me-campaign-card"
    style={{ minHeight: '365px' }}
  >
    {/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */}
    <img className="ui image" src={campaign.photoUrl!} />
    <div className="content">
      <div className="me-card-headline">{campaign.title}</div>
      <div>
        <small>
          <strong>{formatAmount({ cents: campaign.receivedCents })}</strong> von{' '}
          <strong>{formatAmount({ cents: campaign.goalCents ?? 0 })}</strong> gesammelt
        </small>
      </div>
    </div>
    <div className="mb-4 mx-4">
      <div className="overflow-hidden rounded-full bg-me-yellow-300">
        <div
          className="h-2 rounded-full bg-me-yellow-600"
          style={{ width: `${(campaign.receivedCents / (campaign.goalCents || 0)) * 100}%` }}
        ></div>
      </div>
    </div>
  </a>
)

const Group: React.FC<{}> = ({ children }) => (
  <>
    <div className="show-at-small-width ui doubling one cards centered">{children}</div>
    <div className="show-at-high-width ui doubling four cards">{children}</div>
  </>
)

const Dummy = () => (
  <div className="ui raised card" style={{ minHeight: '365px' }}>
    <div className="image">
      <div className="ui placeholder">
        <div className="square image" />
      </div>
    </div>
    <div className="content">
      <div className="ui placeholder">
        <div className="paragraph">
          <div className="full line" />
          <div className="full line" />
        </div>
        <div className="header">
          <div className="medium line" />
        </div>
      </div>
    </div>
  </div>
)

CampaignCard.Group = Group

CampaignCard.Dummy = Dummy
